(function () {
  var MIN_INTERVAL_MS = 10 * 60 * 1000;
  var MAX_INTERVAL_MS = 15 * 60 * 1000;
  var DECREASE_PER_TICK = 1;

  // Deterministic seeded PRNG (mulberry32) so every visitor's browser
  // generates the exact same "random" sequence of intervals from the
  // same seed/index, without needing a shared server.
  function mulberry32(seed) {
    return function () {
      seed |= 0;
      seed = (seed + 0x6D2B79F5) | 0;
      var t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function intervalForTick(epochSeconds, tickIndex) {
    var rand = mulberry32(epochSeconds + tickIndex);
    var r = rand();
    return Math.floor(r * (MAX_INTERVAL_MS - MIN_INTERVAL_MS + 1)) + MIN_INTERVAL_MS;
  }

  // Pure function of "now": replays the deterministic tick sequence
  // from the shared epoch to compute current stock + ms until next tick.
  // Same epoch + same wall-clock time => same result for every visitor.
  // Skips ahead using the average interval to avoid replaying every
  // tick since the epoch on every page load.
  function computeState(epochSeconds, maxStock, resetBelow, nowMs) {
    var AVG_INTERVAL_MS = (MIN_INTERVAL_MS + MAX_INTERVAL_MS) / 2;
    var epochMs = epochSeconds * 1000;
    var elapsed = Math.max(nowMs - epochMs, 0);

    var tickIndex = Math.max(Math.floor(elapsed / AVG_INTERVAL_MS) - 2, 0);
    var cursor = epochMs;
    for (var i = 0; i < tickIndex; i++) {
      cursor += intervalForTick(epochSeconds, i);
    }

    var current = maxStock;
    var cycleLength = maxStock - resetBelow + 1;
    var stepsFromCycleStart = tickIndex % cycleLength;
    current = maxStock - stepsFromCycleStart;
    if (current < resetBelow) current = maxStock;

    while (true) {
      var interval = intervalForTick(epochSeconds, tickIndex);
      var nextCursor = cursor + interval;
      if (nextCursor > nowMs) {
        return {
          current: current,
          msUntilNextTick: nextCursor - nowMs
        };
      }
      current -= DECREASE_PER_TICK;
      if (current < resetBelow) {
        current = maxStock;
      }
      cursor = nextCursor;
      tickIndex++;
    }
  }

  function render(bar, current, max) {
    var currentEl = bar.querySelector('[data-limited-stock-current]');
    var maxEl = bar.querySelector('[data-limited-stock-max]');
    if (currentEl) currentEl.textContent = current;
    if (maxEl) maxEl.textContent = max;
  }

  function initLimitedStockBar(bar) {
    var maxStock = parseInt(bar.dataset.max, 10) || 200;
    var resetBelow = parseInt(bar.dataset.minBeforeReset, 10) || 5;
    var epochSeconds = parseInt(bar.dataset.epoch, 10) || 1750000000;

    function tick() {
      var state = computeState(epochSeconds, maxStock, resetBelow, Date.now());
      render(bar, state.current, maxStock);
      setTimeout(tick, Math.min(state.msUntilNextTick + 250, 2147483647));
    }

    tick();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-limited-stock-bar]').forEach(initLimitedStockBar);
  });
})();
